export function createRandomId() {
	return Math.random().toString(10);
}
